module.exports = __webpack_public_path__ + "static/media/roulette_rules.c9ca6d2c.jpeg";